module.exports = __webpack_public_path__ + "img/border-right.11a792ba.svg";